import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const r = "bulk";
class i extends o {
  /**
   * Imports a list of businesses from a file.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/bulk/business/importer`
   *
   * @param {Blob} file - The file to import.
   * @param {string} [email] - Optional email for notification.
   * @returns {Promise<SuccessResponse>} A promise that resolves to a success response.
   */
  bulkBusinessImport = async (a, t) => {
    const s = new FormData();
    s.append("file", a), t && s.append("email", t);
    const { data: e } = await this.post(
      `${r}/business/importer`,
      s
    );
    return e;
  };
}
export {
  i as BulkImport,
  r as RESOURCE_URI
};
